import React, { useState} from "react";

import { useDispatch, useSelector } from 'react-redux'; 

import { deleteChampsLeadmemo ,modifyChampsLeadmemo} from '../../state/redux';

import { store } from '../../state/redux';


import './Infos.scss';


const classNames = require('classnames'); 
function TitleInputAdresse2({ecran}){
      const dispatch = useDispatch() ;

      const fichememo  = useSelector(state=>state.lead.leadmemo);

      const [focus, setFocus] = useState(false);
      const [valid, setValid] = useState(fichememo.adresse?true :  undefined)   ;
      const [inputValue, setInputValue] = useState('');
      const [suggestions, setSuggestions] = useState([]);
      const [showList, setShowList] = useState(false);


      const handleFocus = ()=>{ setFocus(true);setInputValue(''); }

      const handleBlur = ()=>{  setFocus(false) ;  fichememo.adresse=== undefined  && setValid(false)  }

      const copytoclipboard =()=>{  navigator.clipboard.writeText(inputValue||fichememo.adresse||'');}

      const extractAddress = (place) => {
        const components = place.addressComponents || [];
        const result = { streetNumber: '', street: '', zip: '', city: '', full: place.formattedAddress };

        components.forEach(c => {
            const types = c.types;
            if (types.includes("street_number")) result.streetNumber = c.longText;
            if (types.includes("route")) result.street = c.longText;
            if (types.includes("postal_code")) result.zip = c.longText;
            if (types.includes("locality")) result.city = c.longText;
            });
        return result;
      };

      const handleInputChange = async (e) => {
          const value = e.target.value;
          setInputValue(value);
          dispatch(deleteChampsLeadmemo(['num_departement','ville','code_postal','adresse'] )) 
          if (value.length > 4) {
                try { const google = window.google;
                      const { AutocompleteSuggestion } = await google.maps.importLibrary("places");
                      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                                                                  input: value,
                                                                  includedRegionCodes: ["FR", "GP", "GF", "MQ", "RE"] // Limitation 5 pays
                                                                  });
                                        
                      setSuggestions(suggestions);
                      setShowList(true);
                    }catch (error) {  console.error("Erreur Google Maps:", error);}
          } else { setSuggestions([]);  setShowList(false);  }
      };

      const handleSelect = async (suggestion) => {
            const prediction = suggestion.placePrediction;
            setInputValue(prediction.text.text);
            setShowList(false);
            const placeObj = prediction.toPlace();
            await placeObj.fetchFields({ fields: ["addressComponents", "formattedAddress"]  });
            const detailedAddress = extractAddress(placeObj);
            setValid(true); 
            store.dispatch(modifyChampsLeadmemo({ ville:detailedAddress.city,  adresse: detailedAddress.full,code_postal: detailedAddress.zip , num_departement: detailedAddress.zip?.substring(0,2)})); 
      };

    return( <div className="grouptitleinput  grpadresse"> 
                <div className={classNames("grouptitleinput_containerinput",'adresse' ,{"grouptitleinput_containerinput_valid": valid===true} ,{"grouptitleinput_containerinput_error": valid===false  } , {"focus": focus===true} )}> 
                            
                    <div className='grouptitleinput_containerinput_label' >
                            {ecran==='souscription'?'Adresse':'Adresse ou département'}
                            {(ecran==='souscription')&&<span className='grouptitleinput_containerinput_labelobliged'>*</span>}
                    </div>

                    <input type="text" value={inputValue} onChange={handleInputChange} onFocus={handleFocus}  
                            onBlur={handleBlur} placeholder={fichememo.adresse  || "Entrez votre adresse!"}   />

                    {showList && suggestions.length > 0 && ( <ul className="liste_suggestions"   >
                                                                    {suggestions.map((s, index) => (<li  key={index} onClick={() => handleSelect(s)} className="one_suggestion" >
                                                                                                            {s.placePrediction.text.text}
                                                                                                    </li>))}
                                                                    </ul>)}

                    <div  className='logocopy' onClick={copytoclipboard}  ></div>      
                </div>           
            </div>
    )
}



export default TitleInputAdresse2